export enum NotificationType {
  All = 'All',
  Messages = 'Messages',
  Bookings = 'Bookings',
  Referrals = 'Referrals',
  BookingRequest = 'Booking Request',
}

export interface NotificationSender {
  id?: number;
  name: string;
  avatar?: string;
}

export interface NotificationItem {
  id: number;
  type: NotificationType | string;
  sender: NotificationSender;
  message: string;
  createdAtFormatted: string;
  createdAt: string;
  isRead: boolean;
  channel?: string;
  bookingId?: number;
  ids?: number[];
  count?: number;
  referralId?: number;
}

export interface NotificationState {
  notifications: NotificationItem[];
  loading: boolean;
  error: string | null;
  activeTab: string;
}

export interface GetNotificationsResponse {
  data: NotificationItem[];
  total?: number;
  page?: number;
  limit?: number;
}

export interface GetUnreadCountResponse {
  unreadCount: number;
}